import { NavLink } from 'react-router-dom'
import styles from './Cabecalho.module.css'

export default function Cabecalho() {
    function clicando() {
        window.scrollTo(0,0)
    }
    return (
        <header className={styles.cabecalho}>
            <ul className={styles.cabecalho__navegacao}>
                <li className={styles.cabecalho__item}>
                    <NavLink onClick={() => clicando()} to={"/"} className={styles.cabecalho__link}>Início</NavLink>
                </li>
                <li className={styles.cabecalho__item}>
                    <NavLink onClick={() => clicando()} to={"/projetos"} className={styles.cabecalho__link}>projetos</NavLink>
                </li>
                <li className={styles.cabecalho__item}>
                    <NavLink onClick={() => clicando()} to={"/contato"} className={styles.cabecalho__link}>contato</NavLink>
                </li>
            </ul>
        </header>
    )
}
